"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValuableItemRequest = void 0;
class ValuableItemRequest {
}
exports.ValuableItemRequest = ValuableItemRequest;
//# sourceMappingURL=ValuableItemRequest.js.map